import MultiViewer from 'src/components/MultiViewer/MultiViewer';

export default MultiViewer;